import { AxiosStatic } from "axios";
import { toCamel, toSnake } from "snake-camel";

export interface Item {
  id?: number;
  name: string;
  hansaCode: string | null;
  supplier: string | null;
  /** The kinds of vehicle this item is fitted to; empty means every kind. */
  vehicleTypeIds: number[];
  vehicleTypes?: string | null;
  /** What we charge, kept by hand with the margin in it. */
  price: number;
  /** What we last paid, from the most recent stock purchase. Null if never. */
  lastPurchasePrice?: number | null;
  qtyOnHand: number;
  updatedAt?: string;
}

export interface ItemFilters {
  search?: string | null;
  vehicleTypeId?: number | null;
}

export default ($axios: AxiosStatic) => ({
  async list(filters: ItemFilters = {}): Promise<Item[]> {
    const response = (
      await $axios.get("/api/items", { params: toSnake(filters) })
    ).data.data;
    return response.map((item: any) => toCamel(item) as Item);
  },

  async create(data: Item): Promise<Item> {
    const response = (await $axios.post("/api/items", toSnake(data))).data.data;
    return toCamel(response) as Item;
  },

  async update(id: number, data: Item): Promise<Item> {
    const response = (await $axios.put(`/api/items/${id}`, toSnake(data))).data
      .data;
    return toCamel(response) as Item;
  },

  async remove(id: number): Promise<void> {
    await $axios.delete(`/api/items/${id}`);
  }
});
